import {baseRequestService} from "../base.ts";
import {EventApproversPost} from "../../types/domain.ts";

export const eventsEventIdApproversPost = (eventId: string, data: EventApproversPost) => baseRequestService({
    url: `/events/${eventId}/approvers`,
    method: 'POST',
    data
})